const TemplateAllPeriodList = `query templateAllPeriodList($termTemplateId: Int!){
  templateAllPeriodList(termTemplateId: $termTemplateId){
    termTemplatePeriodId
    name
    desc
    noOfWeeks
    inSprint
    sequence
    
    events{
      termTemplateEventId
      name
      desc
      attendanceRequired
      noOfDaysAfter
      eventTypeId{
        eventTypeId
        name
      }
      eventType
      
      
    }
  }
}`;

const AddTemplatePeriod = `mutation addTemplatePeriod(
  $termTemplateId: Int!,
  $name: String!,
  $noOfWeeks: Int!,
  $inSprint: Boolean!,  
  $desc: String
  ){
  addTemplatePeriod(
    termTemplateId: $termTemplateId,
    name: $name,
    noOfWeeks: $noOfWeeks,
    inSprint: $inSprint,    
    desc: $desc
  ){
    templatePeriod{
      termTemplatePeriodId
      name
      desc
      noOfWeeks
      inSprint
      sequence
      termTemplateId{
        termTemplateId
        name
      }
    }
  }
}`;

const UpdateTemplatePeriod = `mutation updateTemplatePeriod(
  $termTemplatePeriodId:Int!,
  $name: String!,
  $noOfWeeks: Int!,
  $inSprint: Boolean!,  
  $desc: String
  ){
  updateTemplatePeriod(
    termTemplatePeriodId: $termTemplatePeriodId,
    name: $name,
    noOfWeeks: $noOfWeeks,
    inSprint: $inSprint,    
    desc: $desc
  ){
    templatePeriod{
      termTemplatePeriodId
      name
      desc
      noOfWeeks
      inSprint
      sequence
      termTemplateId{
        termTemplateId
        name
      }
    }
  }
}`;

const DeleteTemplatePeriod = `mutation deleteTemplatePeriod(
  $termTemplatePeriodId:Int!
  ){
  deleteTemplatePeriod(
    termTemplatePeriodId: $termTemplatePeriodId,
  ){
    response
  }
}`;

module.exports = {
  TEMPLATE_ALL_PERIODS_QUERY: TemplateAllPeriodList,
  TEMPLATE_ADD_PERIOD_MUTATION: AddTemplatePeriod,
  TEMPLATE_UPDATE_PERIOD_MUTATION: UpdateTemplatePeriod,
  TEMPLATE_DELETE_PERIOD_MUTATION: DeleteTemplatePeriod,
};
